export var Top = 'top';
export var Left = 'left';
export var Right = 'right';
export var Bottom = 'bottom';
export var Center = 'center';

export var Vertical = 'vertical';

export var Start = 'start';
export var Middle = 'middle';
export var End = 'end';

export var Index  = 'index';
export var Label  = 'label';
export var Offset = 'offset';
export var Perc   = 'perc';
export var Perc2  = 'perc2';
export var Size   = 'size';
export var Value  = 'value';

export var GuideLabelStyle = 'guide-label';
export var GuideTitleStyle = 'guide-title';
export var GroupTitleStyle = 'group-title';

export var Symbols = 'symbol';
export var Gradient = 'gradient';
export var Discrete = 'discrete';

// Encoding channels supported by legends
// In priority order of 'canonical' scale
export var LegendScales = [
  'size',
  'shape',
  'fill',
  'stroke',
  'strokeDash',
  'opacity'
];

export var Skip = {
  name: 1,
  interactive: 1
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/guides/constants.js
// module id = 21
// module chunks = 0